// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"
import React, { useState, useContext } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const AccordionContext = React.createContext(null)
export const Accordion = ({
  children,
  controlled,
  defaultActiveItem = null,
  collapseOnDoubleClick = true,
  onChangeExpanded,
  className
}: any) => {
  const [activeTab, setActiveTab] = useState(defaultActiveItem)
  return _jsx(
    AccordionContext.Provider,
    {
      value: {
        activeTab,
        setActiveTab,
        controlled,
        collapseOnDoubleClick,
        onChangeExpanded,
      },
      children: _jsx(
        "div",
        {
          className: `g-accordions-wrapper${className ? ` ${className}` : ""}`,
          children,
        },
        void 0
      ),
    },
    void 0
  )
}
export const AccordionTab = ({
  id,
  title,
  defaultExpanded = false,
  children,
  rightTitle = "",
  className
}: any) => {
  const {
    // @ts-expect-error TS(2339): Property 'activeTab' does not exist on type 'null'... Remove this comment to see the full error message
    activeTab,
    // @ts-expect-error TS(2339): Property 'setActiveTab' does not exist on type 'nu... Remove this comment to see the full error message
    setActiveTab,
    // @ts-expect-error TS(2339): Property 'controlled' does not exist on type 'null... Remove this comment to see the full error message
    controlled,
    // @ts-expect-error TS(2339): Property 'collapseOnDoubleClick' does not exist on... Remove this comment to see the full error message
    collapseOnDoubleClick,
    // @ts-expect-error TS(2339): Property 'onChangeExpanded' does not exist on type... Remove this comment to see the full error message
    onChangeExpanded,
  } = useContext(AccordionContext)
  const [expanded, setExpanded] = useState(defaultExpanded)
  const handleTabClick = () => {
    if (collapseOnDoubleClick && activeTab === id) {
      setActiveTab(null)
    } else {
      setActiveTab(id)
    }
  }
  const tabIsActive = controlled ? activeTab === id : expanded
  return _jsxs(
    "div",
    {
      className: `g-accordionTab-wrapper${
        tabIsActive ? " g-accordionTab-wrapper-expanded" : ""
      }${className ? ` ${className}` : ""}`,
      children: [
        _jsxs(
          "div",
          {
            className: `g-resume-wrapper${
              tabIsActive ? " g-resume-wrapper-active" : ""
            }
      `,
            children: [
              _jsxs(
                "div",
                {
                  className: "g-accordion-title-wrapper",
                  children: [
                    _jsx(
                      "div",
                      {
                        className: `g-accordion-title ${
                          tabIsActive ? "g-accordion-title-active" : ""
                        }`,
                        onClick: () => {
                          controlled ? handleTabClick() : setExpanded(!expanded)
                          onChangeExpanded && onChangeExpanded(id)
                        },
                        children: title,
                      },
                      void 0
                    ),
                    rightTitle &&
                      _jsx(
                        "div",
                        {
                          className: "g-accordion-title-rightcol",
                          children: rightTitle,
                        },
                        void 0
                      ),
                  ],
                },
                void 0
              ),
              _jsx(
                "div",
                {
                  className: "expand-icon-wrapper",
                  onClick: () => {
                    controlled ? handleTabClick() : setExpanded(!expanded)
                    onChangeExpanded && onChangeExpanded(id)
                  },
                  children: _jsx(
                    FontAwesomeIcon,
                    {
                      icon: tabIsActive ? "chevron-up" : "chevron-down",
                      className: "expand-icon",
                    },
                    void 0
                  ),
                },
                void 0
              ),
            ],
          },
          void 0
        ),
        tabIsActive &&
          _jsx(
            "div",
            {
              className: "g-content-wrapper",
              children,
            },
            void 0
          ),
      ],
    },
    void 0
  )
}
